export default {"src":"/_next/static/media/feeding-portion.b701f833.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};